/**
 * Validates a redirect path to prevent open redirects.
 * Only allows relative paths starting with "/" and blocks protocol-relative "//".
 */
export function safeRedirectTo(redirectTo) {
  if (
    redirectTo &&
    redirectTo.startsWith('/') &&
    !redirectTo.startsWith('//')
  ) {
    return redirectTo;
  }
  return '/dashboard';
}
